import React, { useEffect, useState } from "react";

import { Input, Select, Form, Button, Checkbox} from "antd";
import { comunasOptions, IdentidadGeneroUMEOptions, TipoIdentificacionUMEOptions } from "../../../../utils/dataSelectOptions";
import { initialValuesUsuarioModel } from "../../../../models/UsuariosModel/usuarios.model";
import { useRegitrarUsuarioUME } from "../../../../hooks/useRegitrarUsuarioUME";
import { useNavigate } from "react-router";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalDireccion } from "../../../../components/ModalDireccion/ModalDireccion";
import { InputNumero } from "../../../../components/Mascaras/InputNumero/InputNumero";
import { useLocations } from "../../../../hooks/useLocations";
import apiLocation from "../../../../api/Participantes/api.location";
import { Municipio } from "../../../../models/LocationsModels/locations.models";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import {
  POLITICAS_DE_USO,
  TERMINOS_Y_CONDICIONES,
} from "../../../../config/documentosLegales";

interface IProps {
  isComplete: boolean;
}

const PersonaNatural: React.FC<IProps> = (props: IProps) => {
  const [municipios, setMunicipios] = useState<Municipio[]>([]);
  const [department, setDepartment] = useState(true);
  const [diparmentShow] = useState<any>(true);
  const [usuario, setUsuario] = useState<any>(initialValuesUsuarioModel);
  const [tipoCelular] = useState<string>();
  const [openModal, setOpenModal] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState<any>({nombre: '', tipoDocumento: ''});
  const [modalVisualizarDocumento, setModalVisualizarDocumento] = useState(false);

  const { paises, departamentos } = useLocations();

  const navigate = useNavigate();

  const { guardarUsuario } = useRegitrarUsuarioUME();

  useEffect(() => {
  }, []);


  const handleDisabledDepartment = (e: any) => {
    if (e === "CO") {
      return setDepartment(false);
    }
    setUsuario({ ...usuario, pais: e, departamento_nombre: "", departamento: "" });
    return setDepartment(true);
  };

  const handleDepartamento = async (departamento: string) => {
    try {
      const datosDepartameto = departamento.split("-");
      setUsuario({
        ...usuario,
        departamento_nombre: `${datosDepartameto[1]}`,
        departamento: `${datosDepartameto[0]}-${datosDepartameto[1]}`,
        municipio_nombre: "",
        municipio: "",
        comuna_nombre: "",
        comuna: "",
        barrio_nombre: "",
      });


      const municipios = await apiLocation.obtenerMunicipios(datosDepartameto[0]);
      return setMunicipios(municipios);
    } catch (error) {
      return console.error(error);
    }
  };

  const [barrios, setBarrios] = useState([]);
  const [visibleFields, setVisibleFields] = useState(false);

  const handleMunicipio = async (municipio: string) => {
    try {

      const datosMunicipio = municipio.split("-");

      if (datosMunicipio[1] === "MEDELLÍN") {
        setUsuario({
          ...usuario,
          municipio_nombre: `${datosMunicipio[1]}`,
          municipio: `0${datosMunicipio[0]}-${datosMunicipio[1]}`,
          comuna_nombre: "",
          comuna: "",
          barrio_nombre: "",
          barrio: "",
        });

        return setVisibleFields(true);
      }

      setUsuario({
        ...usuario,
        municipio_nombre: `${datosMunicipio[1]}`,
        municipio: `0${datosMunicipio[0]}-${datosMunicipio[1]}`,
        comuna_nombre: "",
        comuna: "",
        barrio_nombre: "",
        barrio: "",
      });


      return setVisibleFields(false);
    } catch (error) {
      return console.log(error);
    }
  };

  const handleComunas = async (comuna: string) => {
    try {
      const datosComuna = comuna.split("-");

      setUsuario({
        ...usuario,
        comuna_nombre: `${datosComuna[1]}`,
        comuna: `0${datosComuna[0]}-${datosComuna[1]}`,
        barrio_nombre: "",
        barrio: "",
      });

      const barrios = await apiLocation.obtenerBarrios(datosComuna[0]);
      setBarrios(barrios);
    } catch (error) {
      return console.log(error);
    }
  };

  const handleBarrios = async (barrio: string) => {
    try {
      const datosBarrio = barrio.split("-");
      setUsuario({
        ...usuario,
        barrio_nombre: `${datosBarrio[1]}`,
        barrio: `${datosBarrio[1]}`,
      });
    } catch (error) {
      return console.log(error);
    }
  };

  const registrarUsuario = async () => {
    const { municipio_nombre, departamento_nombre, barrio_nombre, comuna_nombre, comuna, ...datos } = usuario;

    if (!usuario.politica)
      return openNotification({
        titulo: "Error",
        descripcion: "Falta aceptar las politicas de uso",
        placement: "bottomRight",
      });


    try {
      const { data } = await guardarUsuario(datos);

      if (data.success == 0) {
        if (data.message === 'Permisos insuficientes para realizar esta peticion') {
          let mensaje = 'Permisos insuficientes para realizar esta petición, primero debe ir a www.medellin.gov.co/registrate y registrarse en el portal de la Alcaldía'
          ObjNotificaciones.MSG_ERROR('warning', '¡Advertencia!', mensaje)
          setTimeout(() => {
            window.location.href = "https://www.medellin.gov.co/registrate";
          }, 500);
        }
        return navigate("/login");
      }
      return navigate("/usuario/RegistroExitoso");
    } catch (error: any) {
      console.error(error);
    }
  };

  const handelDireccion = (e: any) => {
    let direccion = e.target.value.trim()
    return setUsuario({
      ...usuario,
      direccion: direccion
    });
  }

  const terminos = () => {
    setTipoDocumento(TERMINOS_Y_CONDICIONES)
    setModalVisualizarDocumento(true);
  }

  const politicas = () => {
    setTipoDocumento(POLITICAS_DE_USO)
    setModalVisualizarDocumento(true);
  }

  const fields = [
    { name: "tipo_sociedad", value: usuario.tipo_sociedad },
    { name: "tipo_entidad", value: usuario.tipo_entidad },
    { name: "tipo_identificacion", value: usuario.tipo_identificacion },
    { name: "documento", value: usuario.documento },
    { name: "nombres", value: usuario.nombres },
    { name: "apellidos", value: usuario.apellidos },
    { name: "correo", value: usuario.correo },
    { name: "direccion", value: usuario.direccion },
    { name: "telefono", value: usuario.telefono },
    { name: "celular", value: usuario.celular },
    { name: "pais", value: usuario.pais },
    { name: "departamento", value: usuario.departamento },
    { name: "departamento_nombre", value: usuario.departamento_nombre },
    { name: "municipio", value: usuario.municipio },
    { name: "municipio_nombre", value: usuario.municipio_nombre },
    { name: "comuna", value: usuario.comuna },
    { name: "comuna_nombre", value: usuario.comuna_nombre },
    { name: "barrio", value: usuario.barrio },
    { name: "barrio_nombre", value: usuario.barrio_nombre },
    { name: "genero", value: usuario.genero },
    { name: "notificacion", value: usuario.notificacion },
    { name: "politica", value: usuario.politica },
  ];

  return (
    <div>
      <Form
        layout="vertical"
        size="large"
        onFinish={registrarUsuario}
        fields={fields}
        onFieldsChange={(_: any, fields: any) => {
          let infoupdate: any = { ...usuario };
          infoupdate[_[0].name[0]] = _[0].value;
          return setUsuario(infoupdate);
        }}
      >
        <div className="row mt-4">
          <div className="col-12 col-md-4">
            <div className="row g-2">

              <div className="col-5">
                <Form.Item
                  className="no-margin"
                  label={
                    <>
                      Tipo de documento
                    </>
                  }
                  required name="tipo_identificacion"
                  rules={[
                    {
                      required: true,
                      message: "Campo obligatorio",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Seleccionar..."
                  >
                    {TipoIdentificacionUMEOptions?.map(({ key, value, text }) => (
                      <Select.Option key={key} value={value}>
                        {text}
                      </Select.Option>
                    ))}
                  </Select>

                </Form.Item>
              </div>
              <div
                className="col-7"
              >
                <Form.Item name="documento" label=" " rules={[
                  { required: true, message: "Campo obligatorio" },
                  { min: 4, message: "Mínimo 4 números" },
                ]}>
                  {/* <Input placeholder="Número" /> */}
                  <InputNumero max={10} name="documento" placeholder="No." texto={usuario.documento} setTexto={setUsuario} alltexto={usuario} />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <Form.Item
              label={
                <>
                  Nombre(s)
                </>
              }
              name="nombres"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}>
              {/* <Input placeholder="" type="text" onChange={onlyCharacters} /> */}
              <InputTexto name="nombres" texto={usuario.nombres} setTexto={setUsuario} alltexto={usuario} onInput={usuario.nombres} />
            </Form.Item>
          </div>

          <div className="col-12 col-md-4">
            <Form.Item
              label={
                <>
                  Apellidos
                </>
              }
              name="apellidos"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}>
              {/* <Input placeholder="" /> */}
              <InputTexto name="apellidos" texto={usuario.apellidos} setTexto={setUsuario} alltexto={usuario} onInput={usuario.apellidos} />
            </Form.Item>
          </div>

          <div className="col-12 col-md-4">
            <Form.Item className="no-margin"
              name="genero"
              label={
                <>
                  Género
                </>}
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}>
              <Select style={{ width: "100%" }} placeholder="Seleccionar género...">
                {IdentidadGeneroUMEOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="col-12 col-md-4">
            <Form.Item
              label={
                <>
                  Correo electrónico

                </>
              }
              name="correo"
              rules={[
                {
                  type: "email",
                  message: "El correo electrónico es invalido",
                },
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </div>

          <div className="col-12 col-md-4">
            <Form.Item
              label={
                <>
                  Dirección de residencia
                </>
              }
              name="direccion"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Input onClick={() => setOpenModal(true)} placeholder="" onBlur={(e: any) => handelDireccion(e)} readOnly={true} />
            </Form.Item>
          </div>

          <div className="col-12 col-md-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353 my-0" style={{paddingBottom: '7px', paddingTop: '5px'}}>
              Número de contacto - <span className="font-family-Montserrat-Regular font-size-10px">&nbsp;Opcional</span>
            </span>
            <div className="row">
              <div className="col-5">
                <Form.Item
                  rules={[
                    {
                      required: false,
                      message: "",
                    },
                  ]}
                >
                  <Select placeholder="Seleccionar...">
                    <Select.Option value="F">Fijo</Select.Option>
                    <Select.Option value="M">Móvil</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              <div
                className="col-7"
              >
                {tipoCelular === "F" ? (
                  <Form.Item  required name="telefono" rules={[
                    {
                      message: "Máximo",
                      max: 10
                    },
                  ]}>
                    <InputNumero name="telefono" texto={usuario.telefono} setTexto={setUsuario} alltexto={usuario} max={10} />
                  </Form.Item>
                ) : (
                  <Form.Item required name="celular">
                    <InputNumero placeholder="Número:" name="celular" texto={usuario.celular} setTexto={setUsuario} alltexto={usuario} max={10} />
                  </Form.Item>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <Form.Item
              label={
                <>
                  País
                </>
              }
              name="pais"
              rules={[
                {
                  required: true,
                  message: "Campo obligatorio",
                },
              ]}
            >
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Seleccionar..."
                onChange={(e: any) => handleDisabledDepartment(e)}
              >
                {paises.map(({ id, prefijo, nombre }) => (
                  <Select.Option key={id} value={prefijo}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className={diparmentShow ? "showFild, col-12 col-md-4" : "hideFild"}>
            <Form.Item
              label={
                <>
                  Departamento
                </>
              }

              name="departamento_nombre"
              rules={[
                (usuario.pais === "CO" &&
                {
                  required: true,
                  message: "Campo obligatorio",
                }
                )

              ]}
            >

              <Select
                placeholder="Seleccionar..." onChange={handleDepartamento} disabled={department}>
                {departamentos.map(({ id, nombre }) => (
                  <Select.Option key={id} value={`${id}-${nombre}`}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className={diparmentShow ? "showFild, col-12 col-md-4" : "hideFild"}>
            <Form.Item
              label="Ciudad"
              name="municipio_nombre"
              rules={[
                (usuario.pais === "CO" &&
                {
                  required: true,
                  message: "Campo obligatorio",
                }
                )

              ]}

            >
              <Select placeholder="Seleccionar..." onChange={handleMunicipio} disabled={municipios.length === 0 ? true : false}>
                {municipios?.map(({ id, nombre }) => (
                  <Select.Option key={id} value={`${id}-${nombre}`}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          {visibleFields && (
            <div className="col-12 col-md-4">
              <Form.Item
                label="Comuna de residencia"
                name="comuna_nombre"
                rules={[
                  (usuario.municipio_nombre === "MEDELLÍN" &&
                  {
                    required: true,
                    message: "Campo obligatorio",
                  }
                  )

                ]}
              >
                <Select placeholder="Seleccionar..." onChange={handleComunas}>
                  {comunasOptions.map(({ key, value }: any) => (
                    <Select.Option key={key} value={`${key}-${value}`}>
                      {key} - {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}

          {visibleFields && (
            <div className="col-12 col-md-4">
              <Form.Item
                label="Barrio de residencia"
                name="barrio_nombre"
                rules={[
                  ((usuario.municipio_nombre === "MEDELLÍN" && barrios.length) > 0 &&
                  {
                    required: true,
                    message: "Campo obligatorio",
                  }
                  )
                ]}

              >
                <Select placeholder="Seleccionar..." onChange={handleBarrios}>
                  {barrios?.map(({ id, nombre }: any) => (
                    <Select.Option key={id} value={`${id}-${nombre.toUpperCase()}`}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}
        </div>
        <div className="mt-3">
          <div className="col">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Checkbox
                checked={usuario.politica}

                onChange={(e: any) => {
                  console.log(e.target);

                  setUsuario({ ...usuario, politica: e.target.checked })
                }}
              >
                <div className="no-margin font-size-12px">
                  Acepto <button type="button" className="enlace-en-texto no-margin font-color-051923bf font-size-12px" onClick={politicas}>Políticas de uso</button> y los{" "}
                  <button type="button" className="enlace-en-texto no-margin font-color-051923bf font-size-12px terminos" onClick={terminos}>Términos y condiciones</button>
                </div>
                
              </Checkbox>

            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 justify-content-flex-end">
            <Button htmlType="submit" className="button-azul-radius">
              Continuar
            </Button>
          </div>
        </div>
      </Form>
      <ModalDireccion
        modal={openModal}
        CancelarModal={() => setOpenModal(false)}
        AceptarModal={() => setOpenModal(false)}
        directions={usuario}
        setDireccion={setUsuario}
        namedirections="direccion"
      />
      <ModalVisualizarDocumentos
        visualizar={modalVisualizarDocumento}
        setVisualizar={setModalVisualizarDocumento}
        state={{ documento: tipoDocumento.nombre }}
        tipoDocumento={tipoDocumento.tipoDocumento}
      />
    </div>
  );
};
export default PersonaNatural;
